import React from "react";

export default function Logo({ className = "h-8 w-auto", showText = false, size = 32 }) {
  if (showText) {
    return <img src="/logo.png" alt="Foliosy" className={className} data-testid="brand-logo-full" />;
  }
  return (
    <img
      src="/logo-mark.png"
      alt="Foliosy"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: "contain" }}
      data-testid="brand-logo-mark"
    />
  );
}
